import React from 'react';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '../../../educators/useStewardshipFilter';
import { tags_educator } from '../../../../utils/query-helpers';

export default function useUsersWhoCreatedProjects(state, network, timestamp) {
  // const stewardshipFilter = useStewardshipFilter();

  return useConnect('user.find', {
    where: {
      eager: {
        $aggregations: _.remove([
          {
            type: 'count',
            alias: 'numberOfProjects',
            relation: 'projects',
            $where: {
              createdAt: {
                $gte: timestamp.start,
                $lte: timestamp.end
              },
              activityId: {
                $null: false
              }
            }
          }
        ]),
        $where: {
          ...tags_educator(),
          state: {
            $ilike: state
          },
          // $or: stewardshipFilter
        },
        $having: {
          numberOfProjects: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
